export const en = [
  {
    name: 'github',
    href: 'https://github.com/pingcap',
  },
  {
    name: 'stackOverflow',
    href: 'https://stackoverflow.com/questions/tagged/tidb',
  },
  {
    name: 'twitter',
    href: 'https://twitter.com/PingCAP',
  },
  {
    name: 'linkedin',
    href: 'https://linkedin.com/company/pingcap',
  },
  {
    name: 'facebook',
    href: 'https://facebook.com/pingcap2015',
  },
  {
    name: 'slack',
    href: 'https://slack.tidb.io/invite?team=tidb-community&channel=everyone&ref=pingcap-docs',
  },
  {
    name: 'youtube',
    href: 'https://youtube.com/channel/UCuq4puT32DzHKT5rU1IZpIA',
  },
  {
    name: 'reddit',
    href: 'https://reddit.com/r/TiDB/',
  },
]

export const zh = [
  {
    name: 'github',
    href: 'https://github.com/pingcap',
  },
  {
    name: 'asktug',
    href: 'https://asktug.com/',
  },
  {
    name: 'twitter',
    href: 'https://twitter.com/PingCAP',
  },
  {
    name: 'linkedin',
    href: 'https://linkedin.com/company/pingcap',
  },
  {
    name: 'facebook',
    href: 'https://facebook.com/pingcap2015',
  },
  {
    name: 'slack',
    href: 'https://slack.tidb.io/invite?team=tidb-community&channel=everyone&ref=pingcap-docs',
  },
  {
    name: 'youtube',
    href: 'https://youtube.com/channel/UCuq4puT32DzHKT5rU1IZpIA',
  },
  {
    name: 'reddit',
    href: 'https://reddit.com/r/TiDB/',
  },
]

export const ja = [
  {
    name: 'github',
    href: 'https://github.com/pingcap',
  },

  {
    name: 'twitter',
    href: 'https://twitter.com/PingCAP_Japan',
  },
  {
    name: 'linkedin',
    href: 'https://www.linkedin.com/company/74771520/',
  },
  {
    name: 'slack',
    href: 'https://slack.tidb.io/invite?team=tidb-community&channel=everyone&ref=pingcap-docs',
  },
  {
    name: 'youtube',
    href: 'https://www.youtube.com/channel/UCatxrGZANSnii2fe7FeEwvg',
  },
]
